import { useEffect, useState } from "react";
import styles from "./styles.module.css";
export default function Spacing({ value, onChange, params }) {
  const [_value, _setValue] = useState({
    marginTop: 0,
    marginRight: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingLeft: 0,
    paddingRight: 0,
  });

  useEffect(() => {
    if (value) {
      _setValue(value);
    } else {
      _setValue({
        marginTop: 0,
        marginRight: 0,
        marginLeft: 0,
        marginBottom: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingLeft: 0,
        paddingBottom: 0,
      });
    }
  }, [value]);

  const handleSelect = (value, key) => {
    const update = { ..._value };
    update[key] = value;
    //_setValue(update);
    onChange(update);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          border: "1px solid var(--main-border-color",
          flexDirection: "column",
        }}
      >
        <div
          className={styles.spaceTitle}
          style={{ position: "absolute", top: 4, left: 4 }}
        >
          Margin
        </div>
        <SpaceInput value={_value} Key={"marginTop"} onChange={handleSelect} />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexGrow: 1,
            width: "100%",
          }}
        >
          <SpaceInput
            value={_value}
            Key={"marginLeft"}
            onChange={handleSelect}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              backgroundColor: "var(--main-light)",
              flexDirection: "column",
            }}
          >
            <div
              className={styles.spaceTitle}
              style={{ position: "absolute", top: 4, left: 4 }}
            >
              Padding
            </div>
            <SpaceInput
              value={_value}
              Key={"paddingTop"}
              onChange={handleSelect}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexGrow: 1,
                width: "100%",
              }}
            >
              <SpaceInput
                value={_value}
                Key={"paddingLeft"}
                onChange={handleSelect}
              />
              <div
                style={{
                  flexGrow: 1,
                }}
              ></div>
              <SpaceInput
                value={_value}
                Key={"paddingRight"}
                onChange={handleSelect}
              />
            </div>
            <SpaceInput
              value={_value}
              Key={"paddingBottom"}
              onChange={handleSelect}
            />
          </div>
          <SpaceInput
            value={_value}
            Key={"marginRight"}
            onChange={handleSelect}
          />
        </div>
        <SpaceInput
          value={_value}
          Key={"marginBottom"}
          onChange={handleSelect}
        />
      </div>
    </div>
  );
}

const SpaceInput = ({ value, Key, onChange }) => {
  const [_value, setValue] = useState("");

  useEffect(() => {
    if (value[Key]) {
      setValue(value[Key]);
    } else {
      setValue(0);
    }
  }, [value, Key]);
  const handleChange = (e) => {
    if (e.target.value === "") {
      setValue("", Key);
    } else {
      setValue(parseInt(e.target.value), Key);
    }
  };

  const handleSave = () => {
    onChange(_value, Key);
  };

  return (
    <input
      onChange={handleChange}
      value={_value}
      className={styles.spaceInput}
      type={"number"}
      onBlur={handleSave}
    />
  );
};
